import { render, staticRenderFns } from "./PatientHistoryItemServices.vue?vue&type=template&id=f2b8d05e&scoped=true&lang=pug&"
import script from "./PatientHistoryItemServices.vue?vue&type=script&lang=js&"
export * from "./PatientHistoryItemServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b8d05e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
